<mat-progress-bar mode="indeterminate" *ngIf="isLoading | async"></mat-progress-bar>
<ned-header *ngIf="showHeader && !hideMobileFilter" [isPLPActive]="checkIfRouteIsProduct()" [activeSearchTerm]="queryParams?.search"
  (searchTermChanged)="search($event)"></ned-header>
<ned-products-filter *ngIf="showFilter"></ned-products-filter>
<div [class.page-content]="!hideFooter">
  <router-outlet></router-outlet>
</div>
<ned-mobile-menu></ned-mobile-menu>
<ned-footer [hide]="hideFooter"></ned-footer>